import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";
import Select from "react-select";
import axios from "axios";

import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function FailureAndSuccessRates() {

  const {setToken} = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  const tabNameFromSearchUrl = new URLSearchParams(search).get("filter[tab_name]");
  const tabNameFromUrl = window.location.hash.substr(1);
  const searchParams = {
    proxyType: new URLSearchParams(search).get("filter[proxy_type]"),
    fetchStatus: new URLSearchParams(search).get("filter[fetch_status]"),
    fromTime: new URLSearchParams(search).get("filter[time]"),
    tabName: tabNameFromSearchUrl ? tabNameFromSearchUrl : tabNameFromUrl
  }
  const [proxyType, setProxyType] = useState({label: 'All', value: '*'});
  const [proxyTypeOptions, setProxyTypeOptions] = useState([]);
  const [fetchStatus, setFetchStatus] = useState({label: 'All', value: '*'});
  const [fromTime, setFromTime] = useState({ label: 'Last 7 days', value: 'now-7d' });
  const [activeTab, setActiveTab] = useState(tabNameFromUrl ? tabNameFromUrl : 'overall_failed_vs_success');

  const fetchStatusOptions = [
    { label: 'All', value: '*' },
    { label: 'Success', value: 'Success' },
    { label: 'Failed', value: 'Failed' },
  ];

  const timeOptions = [
    { label: 'Today', value: 'now%2Fd' },
    { label: 'Last 30 minutes', value: 'now-30m' },
    { label: 'Last 1 hour', value: 'now-1h' },
    { label: 'Last 2 hours', value: 'now-2h' },
    { label: 'Last 4 hours', value: 'now-4h' },
    { label: "Last 10 hours", value: "now-10h" },
    { label: 'Last 12 hours', value: 'now-12h' },
    { label: 'Last 24 hours', value: 'now-24h' },
    { label: 'Last 2 days', value: 'now-2d' },
    { label: 'Last 3 days', value: 'now-3d' },
    { label: 'Last 4 days', value: 'now-4d' },
    { label: 'Last 7 days', value: 'now-7d' },
    { label: 'Last 15 days', value: 'now-15d' },
    { label: 'Last 30 days', value: 'now-30d' },
    { label: 'Last 60 days', value: 'now-60d' },
    { label: 'Last 1 year', value: 'now-1y' }
  ];

  const [UrlParams, setUrlParams] = useState({
    proxyType: "*",
    fetchStatus: '*',
    fromTime: 'now-7d',
    tabName: "overall_failed_vs_success"
  })

  useEffect(() => {
    setSearchParamsData();
    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
        const res = await axios.get('/api/v1/internal/proxy_list_options')
        let proxy_list = []
        res.data.proxy_list.forEach(item => {
          proxy_list.push({ label: item, value: item })
        })
        proxy_list.push({ label: 'All', value: '*' })
        setProxyTypeOptions(proxy_list);

      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  function setSearchParamsData() {
    if (searchParams.proxyType && searchParams.proxyType != proxyType.value) {
      setProxyType({ 
        label: searchParams.proxyType  == '*' ? 'All' :  searchParams.proxyType, 
        value: searchParams.proxyType == 'All' ? '*' : searchParams.proxyType 
      });
    }
    if (searchParams.fetchStatus && searchParams.fetchStatus != fetchStatus.value) {
      setFetchStatus({ 
        label: searchParams.fetchStatus  == '*' ? 'All' :  searchParams.fetchStatus, 
        value: searchParams.fetchStatus == 'All' ? '*' : searchParams.fetchStatus 
      });
    }
    if (searchParams.fromTime && searchParams.fromTime != fromTime.value) {
      setFromTime(timeOptions.filter(item => item.value == searchParams.fromTime)[0]);
    }
    if (searchParams.tabName && searchParams.tabName != activeTab) {
      setActiveTab(searchParams.tabName);
    }
    if (commit == 'Get Data' && searchParams.fromTime && searchParams.proxyType && searchParams.fetchStatus) {
      setUrlParams(searchParams)
    }
  }

  function overallFailedVsSuccessKibanaUrl(kibana_url){
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var proxy_type_val = UrlParams.proxyType == "All" ? "*" : `"${UrlParams.proxyType}"`;
    var fetch_status_val = UrlParams.fetchStatus == "All" ? "*" : `"${UrlParams.fetchStatus}"`;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${UrlParams.fromTime}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'proxies_success_tracker+AND+proxies_type_arr:${proxy_type_val}+and+fetch_status:${fetch_status_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(),schema:metric,type:count),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now-7d,to:now),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:fetch_status.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:5),schema:group,type:terms)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'YYYY-MM-DD+HH:mm')),params:(bounds:(max:'2021-10-06T09:48:39.241Z',min:'2021-09-29T09:48:39.241Z'),date:!t,format:'YYYY-MM-DD+HH:mm',interval:PT3H,intervalESUnit:h,intervalESValue:3)),y:!((accessor:1,aggType:count,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(),legendPosition:right,seriesParams:!((data:(id:'1',label:Count),drawLinesBetweenPoints:!t,interpolate:linear,lineWidth:2,mode:normal,show:!t,showCircles:!t,type:line,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:line,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:Count),type:value))),title:'',type:line))`
  }

  function failedVsSuccessByProxiesKibanaUrl(kibana_url){
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var proxy_type_val = UrlParams.proxyType == "All" ? "*" : `"${UrlParams.proxyType}"`;
    var fetch_status_val = UrlParams.fetchStatus == "All" ? "*" : `"${UrlParams.fetchStatus}"`;

    return `${kibana_url}app/kibana#/visualize/create?type=histogram&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${UrlParams.fromTime}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'proxies_success_tracker+AND+proxies_type_arr:${proxy_type_val}+and+fetch_status:${fetch_status_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(),schema:metric,type:count),(enabled:!t,id:'2',params:(drop_partials:!f,extended_bounds:(),field:'@timestamp',interval:auto,min_doc_count:1,scaleMetricValues:!f,timeRange:(from:now-7d,to:now),useNormalizedEsInterval:!t),schema:segment,type:date_histogram),(enabled:!t,id:'3',params:(field:fetch_status.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:10),schema:group,type:terms)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(series:!((accessor:1,aggType:terms,format:(id:terms,params:(id:string,missingBucketLabel:Missing,otherBucketLabel:Other)),params:())),x:(accessor:0,aggType:date_histogram,format:(id:date,params:(pattern:'YYYY-MM-DD+HH:mm')),params:(bounds:(max:'2021-10-06T10:04:21.270Z',min:'2021-09-29T10:04:21.270Z'),date:!t,format:'YYYY-MM-DD+HH:mm',interval:PT3H,intervalESUnit:h,intervalESValue:3)),y:!((accessor:2,aggType:count,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(show:!f),legendPosition:right,seriesParams:!((data:(id:'1',label:Count),drawLinesBetweenPoints:!t,lineWidth:2,mode:stacked,show:!t,showCircles:!t,type:histogram,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:Count),type:value))),title:'',type:histogram))`
  }

  function barGraphsForAllProxiesKibanaUrl(kibana_url){
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var proxy_type_val = UrlParams.proxyType == "All" ? "*" : `"${UrlParams.proxyType}"`;
    var fetch_status_val = UrlParams.fetchStatus == "All" ? "*" : `"${UrlParams.fetchStatus}"`;

    return `${kibana_url}app/kibana#/visualize/create?type=histogram&indexPattern=8c44ed90-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(pause:!t,value:0),time:(from:'${UrlParams.fromTime}',to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:'proxies_success_tracker+AND+proxies_type_arr:${proxy_type_val}+and+fetch_status:${fetch_status_val}'),uiState:(),vis:(aggs:!((enabled:!t,id:'1',params:(),schema:metric,type:count),(enabled:!t,id:'2',params:(field:proxy_type.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:10),schema:segment,type:terms),(enabled:!t,id:'3',params:(field:fetch_status.raw,missingBucket:!f,missingBucketLabel:Missing,order:desc,orderBy:'1',otherBucket:!f,otherBucketLabel:Other,size:5),schema:group,type:terms)),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,categoryAxes:!((id:CategoryAxis-1,labels:(filter:!t,show:!t,truncate:100),position:bottom,scale:(type:linear),show:!t,style:(),title:(),type:category)),dimensions:(series:!((accessor:1,aggType:terms,format:(id:terms,params:(id:string,missingBucketLabel:Missing,otherBucketLabel:Other)),params:())),x:(accessor:0,aggType:terms,format:(id:terms,params:(id:string,missingBucketLabel:Missing,otherBucketLabel:Other)),params:()),y:!((accessor:2,aggType:count,format:(id:number),params:()))),grid:(categoryLines:!f),labels:(show:!f),legendPosition:right,seriesParams:!((data:(id:'1',label:Count),drawLinesBetweenPoints:!t,lineWidth:2,mode:stacked,show:!t,showCircles:!t,type:histogram,valueAxis:ValueAxis-1)),thresholdLine:(color:%2334130C,show:!f,style:full,value:10,width:1),times:!(),type:histogram,valueAxes:!((id:ValueAxis-1,labels:(filter:!f,rotate:0,show:!t,truncate:100),name:LeftAxis-1,position:left,scale:(mode:normal,type:linear),show:!t,style:(),title:(text:Count),type:value))),title:'',type:histogram))`
  }

  const handleGetData = () => {
    window.location.href = `/internal/proxy_sources/failure_and_success_rates?filter[proxy_type]=${proxyType.value}&filter[fetch_status]=${fetchStatus.value}&filter[time]=${fromTime.value}&filter[tab_name]=${activeTab}&commit=${'Get Data'}`
  }

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit == 'Get Data' ? <a href="/internal/proxy_sources/failure_and_success_rates">Proxy Sources - Failure and Success Rates</a> : 'Proxy Sources - Failure and Success Rates'}
            </BreadcrumbItem>
            {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
                Search
                </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>

    <Card>
      <CardBody>
        <Row>
          <Col sm="4">
            <label className="fw-bold">Proxy Type</label>
            <Select
              value={proxyType}
              options={proxyTypeOptions}
              onChange={option => setProxyType(option)} />
          </Col>
          <Col sm="4">
            <label className="fw-bold">Fetch Status</label>
            <Select
              value={fetchStatus}
              options={fetchStatusOptions}
              onChange={option => setFetchStatus(option)} />
          </Col>
          <Col sm="4">
            <label className="fw-bold">Time</label>
            <Select
              value={fromTime}
              options={timeOptions}
              onChange={option => setFromTime(option)} />
          </Col>
        </Row>
        <Row className="align-items-end mt-2">
          <Col sm="4">
            <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab == 'overall_failed_vs_success' ? 'active' : ''} onClick={() => setActiveTab('overall_failed_vs_success')}>
              Overall Failed vs Success Rates
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'failed_vs_success_by_proxies' ? 'active' : ''} onClick={() => setActiveTab('failed_vs_success_by_proxies')}>
              Failed vs Success Rates By All Proxies
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'bar_graphs_for_all_proxies' ? 'active' : ''} onClick={() => setActiveTab('bar_graphs_for_all_proxies')}>
              Bar Graphs - Failed vs Success Rates By All Proxies
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={'overall_failed_vs_success'}>
            <div className="panel-body">
              <center>
                <span className="fw-bold">Overall Failed vs Success Rates</span><br />
                <a target="_blank" className="link-primary" href={overallFailedVsSuccessKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={overallFailedVsSuccessKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div>
          </TabPane>
          <TabPane tabId={'failed_vs_success_by_proxies'}>
            <div className="panel-body">
              <center>
                <span className="fw-bold">Failed vs Success Rates By All Proxies</span><br />
                <a target="_blank" className="link-primary" href={failedVsSuccessByProxiesKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={failedVsSuccessByProxiesKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div>
          </TabPane>
          <TabPane tabId={'bar_graphs_for_all_proxies'}>
            <div className="panel-body">
              <center>
                <span className="fw-bold">Bar Graphs - Failed vs Success Rates By All Proxies</span><br />
                <a target="_blank" className="link-primary" href={barGraphsForAllProxiesKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={barGraphsForAllProxiesKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="800" width="100%" className="border-0"></iframe>
            </div>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  </Container>
}

